import AxiosClient from '../AxiosClient';
import { SERVICE, ENV } from '../../Config/constants';

const service = AxiosClient.getInstance();

export const getAccountStatusDetailsApi = async () => {
  const url = `${ENV}${SERVICE.REGISTRATION.GET_ACCOUNT_STATUS}`;
  return service.GetApiRequest(url);
};

export const getFacilitiesApi = async (ucmId) => {
  const URL = `${ENV}${SERVICE.REGISTRATION.GET_FACILITIES}?parentUcmId=${ucmId}`;
  return service.GetApiRequest(URL);
};

//Update admin terms and conditions
export const updateAdminTermsApi = async (payload) => {
  const URL = `${ENV}${SERVICE.REGISTRATION.UPDATE_ADMIN_TERMS}`;
  return service.PutApiRequest(URL, payload);
};
